import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@els/els-react--checkbox';
import { InfoTooltipOnClickTrigger, TooltipConstants } from '@Components/InfoTooltip';

import { isOptionChecked } from '../processOptionsUtils';

import './BasicContent.scss';

export default class BasicContent extends React.PureComponent {
  render() {
    const { basicContentDatabases, alertFormDatabases, toggleAlertFormDatabase } = this.props;

    return (
      <div className="create-alert-dialog-section create-alert-dialog-section-basic-content">
        <div className="create-alert-dialog-section-label create-alert-dialog-flex-row">
          BASIC ALERT CONTENT:
          <InfoTooltipOnClickTrigger dataFor={TooltipConstants.ids.AlertCreateDialog} e2eName="info-tooltip-alert-basic-content">
            Basic alert content is available for customers who have their content integrated into Reaxys (for Reaction based alerts only).
            The alert email will contain a link to view the results in Reaxys but not show a preview of the results within the email itself
          </InfoTooltipOnClickTrigger>
        </div>
        <div className="create-alert-dialog-row create-alert-dialog-row-databases">
          <div className="create-alert-dialog-column-label">From databases:</div>
          <div className="create-alert-dialog-column-content">
            <div className="create-alert-dialog-databases-row">
              {basicContentDatabases.map((database) => (
                <Checkbox
                  key={database.value}
                  className="create-alert-dialog-database"
                  checked={isOptionChecked(database.value, alertFormDatabases)}
                  onChange={() => {
                    toggleAlertFormDatabase(database.value);
                  }}
                  label={database.label}
                  title={`Select ${database.label}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BasicContent.propTypes = {
  basicContentDatabases: PropTypes.array.isRequired,
  alertFormDatabases: PropTypes.array.isRequired,
  toggleAlertFormDatabase: PropTypes.func.isRequired,
};
